module.exports = __webpack_public_path__ + "static/turquia-008-3b6313a8b1d989803bae169a6ab0ead2.jpg";